import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import YearGroup from "./routes/YearGroup";
export default store => ({
  path: "year-groups",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [YearGroup(store)],
});
